import React, { useState, useRef } from "react";
import { Icon } from "@iconify/react";
import ReactionPicker from "./ReactionPicker";
import { ReactionType } from "../interfaces/types";
import FloatingReaction from "./FloatingReaction";
import { REACTIONS } from "../../../data/Reactions";

type Props = {
  reaction: ReactionType;
  onReact: (r: ReactionType) => void;
  col?:boolean,
};

const PostReactions: React.FC<Props> = ({ reaction, onReact,col = false }) => {
  const [open, setOpen] = useState(false);
  const [floating, setFloating] = useState<
    { id: number; icon: string; color: string }[]
  >([]);

const closeTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  /* ================= HANDLERS ================= */

  const openPicker = () => {
    if (closeTimeout.current) clearTimeout(closeTimeout.current);
    setOpen(true);
  };

  const closePicker = () => {
    closeTimeout.current = setTimeout(() => setOpen(false), 120);
  };

  const handleSelect = (r: ReactionType) => {
  const data = REACTIONS.find(x => x.type === r);
  if (!data) return;

  // Toggle logic
  if (reaction === r) {
    onReact(null); // remove reaction if same
  } else {
    onReact(r);    // set new reaction
  }

  setOpen(false);

  // Floating animation
  if (reaction !== r) {
    setFloating(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        icon: data.icon,
        color: data.color,
      },
    ]);
  }
};
 

  const active = REACTIONS.find(r => r.type === reaction);

  /* ================= JSX ================= */

  return (
    <div
      className="relative inline-flex"
      onMouseEnter={openPicker}
      onMouseLeave={closePicker}
    >
      {/* Like Button */}
      <button
        type="button"
        className={`flex items-center space-x-1 px-4 py-2 rounded-full
                   hover:bg-charcoalGray/10 dark:hover:bg-deepSlate cursor-pointer transition`}
      >
        {active ? (
          <>
            <Icon
              icon={active.icon}
              className={`w-5 h-5 ${active.color}`}
            />
            <span className={active.color}>{active.label}</span>
          </>
        ) : (
          <>
            <Icon icon="mdi:thumb-up-outline" className="w-5 h-5" />
            <span>Like</span>
          </>
        )}
      </button>

      {/* Reaction Picker */}
      {open && (
        <ReactionPicker
          onSelect={handleSelect}
          onMouseEnter={openPicker}
          onMouseLeave={closePicker}
          col={col}
        />
      )}

      {/* Floating Reactions */}
      {floating.map(f => (
        <FloatingReaction
          key={f.id}
          icon={f.icon}
          color={f.color}
          onComplete={() =>
            setFloating(prev => prev.filter(x => x.id !== f.id))
          }
        />
      ))}
    </div>
  );
};

export default React.memo(PostReactions);
